import { HttpClient } from '@angular/common/http';
import { initializeTranslations } from '@coach-bot/shared/translate';
import { TranslateService } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import { ASSETS_PATH, TRANSLATIONS, TRANSLATIONS_VERSION } from './constants';

export function appInitializeFactory(
  _traceService: Sentry.TraceService,
  translateService: TranslateService,
  httpClient: HttpClient
) {
  return () => initializeTranslations(translateService, httpClient, ASSETS_PATH, TRANSLATIONS_VERSION, TRANSLATIONS);
}
